<svelte:options />

<script>
    import { createEventDispatcher } from 'svelte';
    import CustomRadioButton from './CustomRadioButton.svelte';

    /**
     * @typedef {Object} Props
     * @property {string} [name] - Language 'name' (e.g. "en")
     * @property {string} [displayName] - Language 'display name' (e.g. "Spanish")
     * @property {string} [localisedName] - Localised language name (e.g. "Español")
     * @property {boolean} [selected]
     */
    let {
        name = '',
        displayName = '',
        localisedName = '',
        selected = false
    } = $props();

    const dispatch = createEventDispatcher();

    const handleSelect = () => {
        const eventDetail = { name, displayName };
        dispatch('languageSelected', eventDetail);
    };

    function handleKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            handleSelect();
            event.preventDefault(); // Prevent default spacebar scrolling behavior
        }
    }

    export {
    	name,
    	displayName,
    	localisedName,
    	selected,
    };
</script>

<div
    class="language-container {selected ? 'selected' : ''}"
    onclick={handleSelect}
    onkeydown={handleKeydown}
    role="button"
    tabindex="0"
    aria-label={`Select ${displayName} language`}
>
    <div class="language-info">
        <span class="language-display-name">{displayName} - {name.toUpperCase()}</span>
        <span class="language-name">{localisedName} </span>
    </div>
    <CustomRadioButton {selected} />
</div>

<style>
    .language-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 0.5rem;
        cursor: pointer;
        max-width: 100%;
        transition:
            background-color 0.2s ease,
            border-color 0.2s ease;
    }

    .language-container:hover,
    .language-container:focus {
        background-color: rgba(255, 255, 255, 0.1);
        outline: none;
        border-color: rgba(255, 206, 44);
    }

    .language-container.selected {
        border-color: rgba(255, 206, 44);
        cursor: default;
    }

    .language-container.selected:hover,
    .language-container.selected:focus {
        background-color: unset;
    }

    .language-info {
        display: flex;
        flex-direction: column;
        margin-right: 10px;
    }

    .language-display-name {
        font-size: 1rem;
        font-weight: 500;
    }

    .language-name {
        font-size: 0.875rem;
        color: #b8b8b8;
    }
</style>
